import type { BuilderWeatherTransport } from './weather-cache';
import { normalizeOpenMeteoWeather } from './weather';

/** Public API transport for the prototype; commercial deployments can replace the DI transport. */
export function createOpenMeteoWeatherTransport(fetcher: typeof fetch = fetch): BuilderWeatherTransport {
  return async (request, signal) => {
    const params = new URLSearchParams({
      latitude: String(request.location.latitude),
      longitude: String(request.location.longitude),
      current: 'temperature_2m,apparent_temperature,relative_humidity_2m,weather_code,wind_speed_10m',
      temperature_unit: 'celsius',
      wind_speed_unit: 'kmh',
      timeformat: 'unixtime',
    });
    // Bypass application interceptors and never send device authentication to a weather provider.
    const response = await fetcher(`https://api.open-meteo.com/v1/forecast?${params}`, { signal, credentials: 'omit' });
    if (!response.ok) return null;
    return normalizeOpenMeteoWeather(await response.json());
  };
}
